import type { ReactElement } from 'react';
import { useT } from '../../../../app/di';
import { Alert } from '../../../../ui-kit/Alert/Alert';
import { Button } from '../../../../ui-kit/Button/Button';
import { FormAlert, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

export interface MarkPublishedValues {
  url: string;
  /** Время выхода в поясе блога, «ГГГГ-ММ-ДДTчч:мм»; пусто — сейчас. */
  publishedAt: string;
}

/** PUB-UC-3, PUB-UC-2.CC-1: отметить выход; раньше срока — с предупреждением. */
export function MarkPublishedForm({ early, onSubmit }: { early: boolean; onSubmit(values: MarkPublishedValues): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<MarkPublishedValues>({ defaultValues: { url: '', publishedAt: '' }, fields: ['url', 'publishedAt'], onSubmit });
  const disabled = form.formState.isSubmitting;
  return (
    <form className="u-stack" onSubmit={submit} noValidate>
      {early ? <Alert tone="info">{t('publishing.package.early')}</Alert> : null}
      <FormAlert form={form} />
      <FormTextField control={form.control} name="url" label={t('publishing.package.url')} hint={t('publishing.package.urlHint')} type="url" disabled={disabled} />
      <FormTextField control={form.control} name="publishedAt" label={t('publishing.package.publishedAt')} hint={t('publishing.package.publishedAtHint')} type="datetime-local" disabled={disabled} />
      <div>
        <Button type="submit" variant="primary" icon="check" loading={disabled}>
          {t('publishing.package.mark')}
        </Button>
      </div>
    </form>
  );
}
